// extracted by mini-css-extract-plugin
export var border = "_h-8";
export var brand = "_h-t";
export var button = "_h-l";
export var center = "_h-a";
export var centered = "_h-6";
export var closeButton = "_h-c";
export var disabledWrapper = "_h-m";
export var error = "_h-p";
export var extraLarge = "_h-4";
export var extraSmall = "_h-1";
export var fill = "_h-i";
export var footer = "_h-h";
export var footerAction = "_h-j";
export var footerButtons = "_h-k";
export var header = "_h-7";
export var headerWithClose = "_h-d";
export var icon = "_h-o";
export var info = "_h-s";
export var inline = "_h-9";
export var large = "_h-3";
export var main = "_h-e";
export var modal = "_h-0";
export var nearFull = "_h-5";
export var neutral = "_h-u";
export var noPadding = "_h-g";
export var none = "_h-v";
export var scrollable = "_h-f";
export var small = "_h-2";
export var success = "_h-r";
export var tight = "_h-n";
export var titleIcon = "_h-b";
export var warn = "_h-q";